
export const CapitalInfo = {

    methods: {
        //查询所有客资
        async getCapital_info(type) {
            let roleArr = ['推广主管','系统管理员','电商主管'];//可查看所有客资
            let roleArr2 = ['推广专员'];//只能查看自己的客资
            let roleArr3 = ['网销专员'];//只能查看自己的客资
            let roleArr4 = ['网销组长'];//查看本组客资
            let deptid =roleArr.includes(this.userInfo.roleName) ? '' : this.userInfo.deptid
            let promoter =roleArr2.includes(this.userInfo.roleName) ? this.userInfo.employeeid : '';
            let custom_service =roleArr3.includes(this.userInfo.roleName) ? this.userInfo.employeeid : '';
            let group_leader =roleArr4.includes(this.userInfo.roleName) ? this.userInfo.deptid : '';

            let emarr = await this.getEmployee('', '', 'all')//员工
            let deptarr = await this.getDeptall();//部门
            // let statusarr = await this.getdicontent('跟踪状态');
            let sourceArr = await this.getdicontent('来源');
            let resobj = {
                state: 0,
            }
            if (deptid) {//如果有部门
                resobj.deptid = deptid
            }
            if(promoter){//如果是推广专员
                resobj.promoter = promoter;
                delete resobj.deptid;
            }
            if(custom_service){//如果是网销专员
              resobj.custom_service = custom_service;
              delete resobj.deptid;
            }
            if(group_leader){//如果是网销组长
              resobj.group_leader = group_leader;
              // delete resobj.deptid;
            }
            if (type == 1) {//待分配
                //拿length
                let { data: { data: ret } } = await this.$http.get('/api/custom_capital_info/getToBeCollectioned')
                this.tableConfig.total = ret.list.length;
                //分页
                let { data: { data: retPage } } = await this.$http.get('/api/custom_capital_info/getToBeCollectionedPage', {
                    currPage: this.tableConfig.page,
                    jumpRecNo: this.tableConfig.page * this.tableConfig.size - this.tableConfig.size,
                    pageSize: this.tableConfig.size,
                    state: 0,
                })
                let arrList = retPage.list;
                await this.FormatCapital_info(arrList, emarr, deptarr, sourceArr)
                return retPage.list
            } else if (type != 0) {
                resobj.status = type
            }

            //所有客资
            //拿length
            let { data: { data: ret } } = await this.$http.get('/api/custom_capital_info/getBycon', {
                ...resobj,
                state: 0,
            })
            this.tableConfig.total = ret.list.length;
            //分页
            let { data: { data: retPage } } = await this.$http.get('/api/custom_capital_info/getBycon', {
                ...resobj,
                jumpRecNo: this.tableConfig.page * this.tableConfig.size - this.tableConfig.size,
                pageSize: this.tableConfig.size,
                state: 0,
            })

            let arrList = retPage.list;
            await this.FormatCapital_info(arrList, emarr, deptarr, sourceArr)

            return retPage.list
        },

        //客资条件查询
        async search_info(type, obj) {
            let emarr = await this.getEmployee('', '', 'all')//员工
            let deptarr = await this.getDeptall();//部门
            // let statusarr = await this.getdicontent('跟踪状态');
            let sourceArr = await this.getdicontent('来源');
            if (type != 0 && type != 1) {
                obj.status = type
            }

            //所有客资
            //拿length
            let { data: { data: ret } } = await this.$http.get('/api/custom_capital_info/getBycon', {
                ...obj,
                state: 0,
            })
            this.tableConfig.total = ret.list.length;
            //分页
            let { data: { data: retPage } } = await this.$http.get('/api/custom_capital_info/getBycon', {
                ...obj,
                jumpRecNo: this.tableConfig.page * this.tableConfig.size - this.tableConfig.size,
                pageSize: this.tableConfig.size,
                state: 0,
            })

            let arrList = retPage.list;
            await this.FormatCapital_info(arrList, emarr, deptarr, sourceArr)
            return retPage.list
        },
        //查询条数
        async InitLength(val) {
            let roleArr = ['推广主管','系统管理员','电商主管'];//可查看所有客资
            let roleArr2 = ['推广专员'];//只能查看自己的客资
            let roleArr3 = ['网销专员'];//只能查看自己的客资
            let deptid =roleArr.includes(this.userInfo.roleName) ? '' : this.userInfo.deptid
            var promoter =roleArr2.includes(this.userInfo.roleName) ? this.userInfo.employeeid : '';
            var custom_service =roleArr3.includes(this.userInfo.roleName) ? this.userInfo.employeeid : '';
            let total = [];
            let resobj = {
                state: 0,
            }
            if (deptid) {//如果有部门
                resobj.deptid = deptid
            }
            if(promoter){//如果是推广专员
                resobj.promoter = promoter
                delete resobj.deptid;
            }
            if(custom_service){//如果是网销专员
              resobj.custom_service = custom_service
              delete resobj.deptid;
          }
            for (let i = 0; i <= 5; i++) {
                if (i == 0) {//全部
                    let { data: { data: ret } } = await this.$http.get('/api/custom_capital_info/getBycon', {
                        ...resobj
                    })
                    total.push(ret.list.length)
                } else if (i == 1) {//待分配
                    if(promoter != ''){//如果是推广专员，不允许看到待分配的内容
                        total.push(0);  
                       
                    }else{
                        let { data: { data: ret } } = await this.$http.get('/api/custom_capital_info/getToBeCollectioned')
                        total.push(ret.list.length)
                    }
                  
                } else {
                    let { data: { data: ret } } = await this.$http.get('/api/custom_capital_info/getBycon', {
                        ...resobj,
                        status: i
                    })
                    total.push(ret.list.length)
                }

            }
            this.$store.commit('uptabstotal', total);//存到vuex,更新客资信息

        },
        //查询统计数据
        async Statistics(data) {
            let order ={
                total:0,//总订单数
                order_amount:0,//订单金额
                payment:0,//收款金额
                collection_rate:0,//收款率
                aver:0,//订单平均价
            }
            //数据
            for(let i=0;i<data.length;i++){
                let {data:{data:ret}} = await this.$http.get('/api/custom_capital_online_order/getBycustomid',{
                    customid:data[i].id
                 })   
                 if(ret.list.length > 0){
                    order.total += ret.list.length
                    for(let j =0;j<ret.list.length;j++){
                        order.order_amount += ret.list[j].order_amount;//订单金额
                        order.payment += ret.list[j].payment;//收款金额
                    }
                 }
                 if(i === data.length -1){
                    if(order.payment != 0 || order.order_amount !=0){
                        order.collection_rate = Number((order.payment /order.order_amount).toFixed(2));//收款率
                        order.aver = Number((order.order_amount / order.total).toFixed(2));//订单平均价 
                    }
                  
                 }

            }

        
            this.$store.commit('upStatistics',order);//存到vuex,更新统计数据
        },
        //格式化客资列表
        async FormatCapital_info(arrList, emarr, deptarr, sourceArr) {
            for (let i = 0; i < arrList.length; i++) {
                if (arrList[i].custom_service) {//指定客服存在时才查找
                    arrList[i].custom_serviceName = emarr.filter(it => it.employeeid == arrList[i].custom_service)[0]?.name;//指定客服
                }
                if (arrList[i].status) {//存在客资状态时才查找
                    arrList[i].statusName = await this.getreason(arrList[i].id, arrList[i].status)//客资状态
                }
                if (arrList[i].source) {//存在来源时才查找
                    arrList[i].sourceName = sourceArr.filter(it => it.id == arrList[i].source)[0]?.dic_content;//来源
                }

                arrList[i].promoterName = emarr.filter(it => it.employeeid == arrList[i].promoter)[0]?.name;//推广人
                arrList[i].deptName = deptarr.filter(it => it.deptid == arrList[i].deptid)[0]?.deptname;//门店
            }

        },
        //返回流失原因
        async getreason(id, status) {
            let cause = '新客资'
            if (status == 3) {
                const { data: { data: s1 } } = await this.$http.get('/custom_capital_tracking_remider/getBycustomid', {
                    customid: id
                })
                const s2 = await this.getcapital_dictionaryByid(s1.list?.[0]?.tracking_reminder_type)
                cause = s2
            } else if (status == 4) {
                cause = '在线有效订单'
            } else if (status == 5) {
                const { data: { data: s1 } } = await this.$http.get('/api/custom_capital_loss_due_approve/getBycustomid', {
                    customid: id
                })
                if(s1.list.length >0 ){
                    if (s1.list?.[0].approve_result == 0) {
                        cause = '待审批'
                    } else if (s1.list?.[0].approve_result == 1) {
                        cause = '无效'
                    } else {//
                        cause = '已驳回'
                    }
                }
               

            }

            return cause
        },
        //根据id查询词典内容dictionary_name
        async getcapital_dictionaryByid(id) {
            if (!id) return
            const { data: { data: s1 } } = await this.$http.get('/dictionary_content/getByid', {
                id: id
            })
            return s1.dic_content
        },
        //删除单条客资
        async delCapital_info(obj) {
            let ret = await this.$http.delete('/api/custom_capital_info/delCustom_capital_info', obj)
            if (ret.data.code == '200') {
                this.$message({ message: '删除成功', type: 'success' });
            } else {
                this.$message.error('删除失败');
            }
        },
        //格式化单条客资
        async fromtCapital_info(obj) {
            let arr = await this.getEmployee('', '', 'all')//员工
            let deptarr = await this.getDeptall();//部门
            let statusarr = await this.getdicontent('跟踪状态');
            let sourceArr = await this.getdicontent('来源');
            let arrList = [obj];
            for (let i = 0; i < arrList.length; i++) {
                if (arrList[i].custom_service) {//指定客服存在时才查找
                    arrList[i].custom_serviceName = arr.filter(it => it.employeeid == arrList[i].custom_service)[0]?.name;//指定客服
                }
                if (arrList[i].status) {//存在客资状态时才查找
                    arrList[i].statusName = await this.getreason(arrList[i].id, arrList[i].status)//客资状态
                }
                if (arrList[i].source) {//存在来源时才查找
                    arrList[i].sourceName = sourceArr.filter(it => it.id == arrList[i].source)[0]?.dic_content;//来源
                }

                arrList[i].promoterName = arr.filter(it => it.employeeid == arrList[i].promoter)[0]?.name;//推广人
                arrList[i].deptName = deptarr.filter(it => it.deptid == arrList[i].deptid)[0]?.deptname;//门店
            }

            return [obj]
        },



        //新增客资
        async handle_addCapital_info(val) {
            this.$refs.infoFrom.$refs['form'].validate(async(valid) => {
                if (valid) {
                    let obj = JSON.parse(JSON.stringify(val))
                    obj.operator = this.userInfo.employeeid;//最后修改人
                    obj.custom_service = obj.custom_service ? obj.custom_service.employeeid : '';//指定客服
                    obj.promoter = obj.promoter ? obj.promoter.employeeid : '';//推广人
                    obj.directional = obj.directional.join(',');//客资定向
                    obj.status = obj.custom_service ? 2 : 1;//选了客服就传2，不选传1
                    if (obj.mom_mobile == '' && obj.mom_wechat =='') {
                      this.$message.error('妈妈手机号和微信号必须填一个');
                    }else{
                        let { data: ret } = await this.$http.post('/api/custom_capital_info/addCustom_capital_info', obj)
                      if (ret.code == '200') {
                          this.$message({ message: '新增成功', type: 'success' });
                          this.dialogConfig.dialogVisible = false;//关闭弹框
                          this.$refs.table01.initTableItems();//刷新表格
                      } else {
                          this.$message.error('新增失败');
                      }
                    }
        
                    
                } else {
                  return false;
                }
              });
          
        },

        //分配客资
        async handle_distribution(data, emObj) {
            data.forEach(async (item, index) => {
                let row = {
                    customid: item.id,
                    o_custom_service: item.custom_service,
                    n_custom_service: emObj[0].employeeid,
                    operator: this.userInfo.employeeid
                }
                //新增分配日志
                let { data: { data: res } } = await this.$http.post('/custom_capital_distribution/addCustom_capital_distribution', row)

                if (res) {
                    item.custom_service = emObj[0].employeeid;//切换客服
                    // item.status = 2;//切换状态
                    let { data: { data: ret } } = await this.$http.put('/api/custom_capital_info/updCustom_capital_info', item);
                }

                if (index == data.length - 1) {
                    this.$message({ message: '分配成功', type: 'success' });
                    this.dialogConfig.dialogVisible = false;//关闭弹框
                    this.$refs.table01.initTableItems();//刷新表格
                }
            })
        },
        //转移客资
        async handle_transferbution(data, emObj) {
            data.forEach(async (item, index) => {
                let row = {
                    customid: item.id,
                    o_custom_service: item.custom_service,
                    n_custom_service: emObj[0].employeeid,
                    operator: this.userInfo.employeeid
                }
                //新增分配日志
                let { data: { data: res } } = await this.$http.post('/custom_capital_distribution/addCustom_capital_distribution', row)

                if (res) {
                    item.custom_service = emObj[0].employeeid;//切换客服
                    // item.status = 2;//切换状态
                    let { data: { data: ret } } = await this.$http.put('/api/custom_capital_info/updCustom_capital_info', item);
                }
                if (index == data.length - 1) {
                    this.$message({ message: '转移成功', type: 'success' });
                    this.dialogConfig.dialogVisible = false;//关闭弹框
                    this.$refs.table01.initTableItems();//刷新表格
                }
            })
        },
        //获取转移日志
        async getdistriArr(customid) {
            let { data: { data: ret } } = await this.$http.get('/custom_capital_distribution/getBycustomid', {
                customid: customid
            })
            ret.list.forEach(async item => {
                item.o_custom_serviceName = '';
                item.n_custom_serviceName = '';
                item.oldSrc = '';
                let oldName = await this.getEmployeeId(item.o_custom_service);
                let newName = await this.getEmployeeId(item.n_custom_service);
                //查询头像（只差旧的）
                let { data: { data: oldSrc } } = await this.$http.get('/api/custom_capital_employee_photo/getByemployeeid', {
                    employeeid: item.o_custom_service
                })
                item.o_custom_serviceName = oldName.name;
                item.n_custom_serviceName = newName.name;
                item.oldSrc = oldSrc.list[0]?.urlstring ?? '';
            })
            return ret.list ?? []
        },
        //跟踪确认
        async addtracking_remider(val, obj, ref) {
            val.customid = obj.id;
            val.operator = this.userInfo.employeeid;
            obj.status = 3;

            //修改客资信息
            let res = await this.$http.put('/api/custom_capital_info/updCustom_capital_info', obj)
            if (res.data.code == '200') {
                let { data: { data: ret } } = await this.$http.post('/custom_capital_tracking_remider/addCustom_capital_tracking_remider', val)
                if (ret) {
                    let newobj = await this.fromtCapital_info(res.data.data);//先格式化单条数据
                    this.$store.commit('upcapital_info', newobj[0]);//存到vuex,更新客资信息
                    this.$message({ message: '跟踪成功', type: 'success' });
                } else {
                    this.$message.error('跟踪失败');
                    this.contentLoading = false;
                }
            }


        },
        //查询当前用户所有跟踪提醒
        async trackingremider(customid) {
            let { data: { data: ret } } = await this.$http.get('/custom_capital_tracking_remider/getBycustomid', {
                customid: customid
            })
            let nameList = await this.getdicontent('跟踪状态');
            this.tableConfig.total = ret.list.length;
            //查找类型中文
            ret.list.forEach(item => {
                item.tracking_reminder_name = nameList.filter(it => it.id == item.tracking_reminder_type)[0]?.dic_content;
            })
            return ret.list
        },
        //流失确认
        async addloss_due(val, obj) {

            val.customid = obj.id;
            val.operator = this.userInfo.employeeid;
            // obj.status = 5;
            //修改客资信息
            let ret = await this.$http.put('/api/custom_capital_info/updCustom_capital_info', obj)
            if (ret.data.code == '200') {
                let { data: { data: res } } = await this.$http.post('/api/custom_capital_loss_due/addCustom_capital_loss_due', val)
                if (res) {
                    let newobj = await this.fromtCapital_info(ret.data.data);//先格式化单条数据
                    this.$store.commit('upcapital_info', newobj[0]);//存到vuex,更新客资信息
                }
                this.$message({ message: '失效流失确认成功', type: 'success' });
            } else {
                this.$message.error('失效流失确认失败');
                this.contentLoading = false;
            }

        },
        //订单确认
        async addonline_order(val, obj) {
            let newval = JSON.parse(JSON.stringify(val))
            newval.payment_operator = newval.payment_operator ? newval.payment_operator.employeeid : '',
                newval.customid = obj.id;
            newval.operator = this.userInfo.employeeid;
            obj.status = 4;
            //修改客资信息
            let ret = await this.$http.put('/api/custom_capital_info/updCustom_capital_info', obj)
            if (ret.data.code == '200') {
                //新增订单
                let { data: { data: res } } = await this.$http.post('/api/custom_capital_online_order/addCustom_capital_online_order', newval)
                if (res) {
                    let newobj = await this.fromtCapital_info(ret.data.data);//先格式化单条数据
                    this.$store.commit('upcapital_info', newobj[0]);//存到vuex,更新客资信息
                    this.$message({ message: '订单确认成功', type: 'success' });
                }

            } else {
                this.$message.error('订单确认失败');
                this.contentLoading = false;
            }


        },
        //查询当前用户所有在线订单
        async online_order(customid) {
            let { data: { data: ret } } = await this.$http.get('/api/custom_capital_online_order/getBycustomid', {
                customid: customid
            })
            let order_wayList = await this.getdicontent('订单方式');
            let order_typeList = await this.getdicontent('订单类型');
            let payment_styleList = await this.getdicontent('收款方式');



            this.tableConfig.total = ret.list.length;
            //查找类型中文
            ret.list.forEach(async item => {
                item.payment_operatorName = '';
                //订单方式
                item.order_wayName = order_wayList.filter(it => it.id == item.order_way)[0]?.dic_content;
                //订单类型
                item.order_typeName = order_typeList.filter(it => it.id == item.order_type)[0]?.dic_content;
                //收款方式
                item.payment_styleName = payment_styleList.filter(it => it.id == item.payment_style)[0]?.dic_content;
                //订单人
                let payment_operatorName = await this.getEmployeeId(item.payment_operator)
                item.payment_operatorName = payment_operatorName.name;
            })
            return ret.list
        },
        //更改推广渠道
        async upsource(val, obj) {
      
            obj.deptid = val.deptid;
            obj.source = val.source;
            obj.promoter = val.promoter?.employeeid ?? '';//推广人

            //修改客资信息
            let res = await this.$http.put('/api/custom_capital_info/updCustom_capital_info', obj)
            if (res.data.code == '200') {
                let newobj = await this.fromtCapital_info(res.data.data);//先格式化单条数据
                this.$store.commit('upcapital_info', newobj[0]);//存到vuex,更新客资信息
                this.$message({ message: '设置推广渠道成功', type: 'success' });

            } else {
                this.$message.error('设置推广渠道失败');
            }

        },
        //修改客资基本信息
        async upCapital_info_handle(obj) {
            if (!obj) return
            let res = await this.$http.put('/api/custom_capital_info/updCustom_capital_info', obj)
            if (res.data.code == '200') {
                let newobj = await this.fromtCapital_info(res.data.data);//先格式化单条数据
                this.$store.commit('upcapital_info', newobj[0]);//存到vuex,更新客资信息
                this.$message({ message: '编辑客资信息成功', type: 'success' });

            } else {
                this.$message.error('编辑客资信息失败');
                this.Updialogloading = false;
            }
        },
        //修改客资备注
        async upCapital_info_memo(obj) {
            let res = await this.$http.put('/api/custom_capital_info/updCustom_capital_info', obj)
            if (res.data.code == '200') {
                let newobj = await this.fromtCapital_info(res.data.data);//先格式化单条数据
                this.$store.commit('upcapital_info', newobj[0]);//存到vuex,更新客资信息
                this.$message({ message: '修改客资备注成功', type: 'success' });

            } else {
                this.$message.error('修改客资备注失败');
                this.drawerLoading = false;
            }
        }
    },
}